import React, { useState } from 'react'

//
import Checkbox from '../Checkbox'
import IconButton from '../IconButton'

const MultiFilterBlock = ({
  title = '',
  items = [],
  defaultOpen = false,
  handleSelect = () => null
}) => {
  const [isShown, setIsShown] = useState(defaultOpen)

  const handleExpand = () => {
    setIsShown(!isShown)
  }

  const handleChange = (op, itemId) => {
    items[itemId].checked = op
    handleSelect(items)
  }

  if (!items?.length) {
    return null
  }

  return (
    <div className="c-multi-filter">
      <div className="c-multi-filter__title">
        <span>{title}</span>
        <IconButton
          icon={isShown ? 'tabler-chevron-up' : 'tabler-chevron-down'}
          handleClick={handleExpand}
          black={!isShown}
        />
      </div>

      {isShown ? (
        <div>
          {items.map((item) => (
            <Checkbox
              key={item.id}
              textLabel={item.label}
              checked={item.checked}
              handleChange={(op) => handleChange(op, item.id)}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default MultiFilterBlock
